export const ThreeDotsIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00004 8.66699C8.36823 8.66699 8.66671 8.36852 8.66671 8.00033C8.66671 7.63214 8.36823 7.33366 8.00004 7.33366C7.63185 7.33366 7.33337 7.63214 7.33337 8.00033C7.33337 8.36852 7.63185 8.66699 8.00004 8.66699Z"
        fill="#667085"
      />
      <path
        d="M8.00004 4.00033C8.36823 4.00033 8.66671 3.70185 8.66671 3.33366C8.66671 2.96547 8.36823 2.66699 8.00004 2.66699C7.63185 2.66699 7.33337 2.96547 7.33337 3.33366C7.33337 3.70185 7.63185 4.00033 8.00004 4.00033Z"
        fill="#667085"
      />
      <path
        d="M8.00004 13.3337C8.36823 13.3337 8.66671 13.0352 8.66671 12.667C8.66671 12.2988 8.36823 12.0003 8.00004 12.0003C7.63185 12.0003 7.33337 12.2988 7.33337 12.667C7.33337 13.0352 7.63185 13.3337 8.00004 13.3337Z"
        fill="#667085"
      />
      <path
        d="M8.00004 8.66699C8.36823 8.66699 8.66671 8.36852 8.66671 8.00033C8.66671 7.63214 8.36823 7.33366 8.00004 7.33366C7.63185 7.33366 7.33337 7.63214 7.33337 8.00033C7.33337 8.36852 7.63185 8.66699 8.00004 8.66699Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.00004 4.00033C8.36823 4.00033 8.66671 3.70185 8.66671 3.33366C8.66671 2.96547 8.36823 2.66699 8.00004 2.66699C7.63185 2.66699 7.33337 2.96547 7.33337 3.33366C7.33337 3.70185 7.63185 4.00033 8.00004 4.00033Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.00004 13.3337C8.36823 13.3337 8.66671 13.0352 8.66671 12.667C8.66671 12.2988 8.36823 12.0003 8.00004 12.0003C7.63185 12.0003 7.33337 12.2988 7.33337 12.667C7.33337 13.0352 7.63185 13.3337 8.00004 13.3337Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CopyIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2541_103774)">
        <path
          d="M13.3333 13.3337V15.667C13.3333 16.6004 13.3333 17.0671 13.1516 17.4236C12.9918 17.7372 12.7369 17.9922 12.4233 18.152C12.0668 18.3337 11.6 18.3337 10.6666 18.3337H4.33329C3.39987 18.3337 2.93316 18.3337 2.57664 18.152C2.26304 17.9922 2.00807 17.7372 1.84828 17.4236C1.66663 17.0671 1.66663 16.6004 1.66663 15.667V9.33366C1.66663 8.40024 1.66663 7.93353 1.84828 7.57701C2.00807 7.2634 2.26304 7.00844 2.57664 6.84865C2.93316 6.66699 3.39987 6.66699 4.33329 6.66699H6.66663M9.33329 13.3337H15.6666C16.6 13.3337 17.0668 13.3337 17.4233 13.152C17.7369 12.9922 17.9918 12.7372 18.1516 12.4236C18.3333 12.0671 18.3333 11.6004 18.3333 10.667V4.33366C18.3333 3.40024 18.3333 2.93353 18.1516 2.57701C17.9918 2.2634 17.7369 2.00844 17.4233 1.84865C17.0668 1.66699 16.6 1.66699 15.6666 1.66699H9.33329C8.39987 1.66699 7.93316 1.66699 7.57664 1.84865C7.26304 2.00844 7.00807 2.2634 6.84828 2.57701C6.66663 2.93353 6.66663 3.40024 6.66663 4.33366V10.667C6.66663 11.6004 6.66663 12.0671 6.84828 12.4236C7.00807 12.7372 7.26304 12.9922 7.57664 13.152C7.93316 13.3337 8.39987 13.3337 9.33329 13.3337Z"
          stroke="#667085"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2541_103774">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ShareIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.65833 11.2587L13.35 14.5753M13.3417 5.42533L7.65833 8.74199M18 4.16699C18 5.5477 16.8807 6.66699 15.5 6.66699C14.1193 6.66699 13 5.5477 13 4.16699C13 2.78628 14.1193 1.66699 15.5 1.66699C16.8807 1.66699 18 2.78628 18 4.16699ZM8 10.0003C8 11.381 6.88071 12.5003 5.5 12.5003C4.11929 12.5003 3 11.381 3 10.0003C3 8.61961 4.11929 7.50033 5.5 7.50033C6.88071 7.50033 8 8.61961 8 10.0003ZM18 15.8337C18 17.2144 16.8807 18.3337 15.5 18.3337C14.1193 18.3337 13 17.2144 13 15.8337C13 14.4529 14.1193 13.3337 15.5 13.3337C16.8807 13.3337 18 14.4529 18 15.8337Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CountriesIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2541_101034)">
        <path
          d="M2.05064 4.98822L4.90933 7.03011C5.05808 7.13636 5.13246 7.18948 5.2103 7.20173C5.27879 7.2125 5.34894 7.20164 5.41097 7.17067C5.48147 7.13548 5.53631 7.06236 5.64599 6.91611L6.25006 6.11069C6.28107 6.06933 6.29658 6.04865 6.31481 6.03082C6.33099 6.01498 6.34875 6.00083 6.3678 5.98859C6.38926 5.97481 6.41288 5.96431 6.46012 5.94332L9.03918 4.79707C9.14609 4.74955 9.19954 4.72579 9.23985 4.68869C9.2755 4.65587 9.30357 4.61568 9.3221 4.5709C9.34305 4.52028 9.34694 4.46191 9.35472 4.34518L9.54356 1.51261M8.99998 8.99967L10.744 9.74711C10.9463 9.83383 11.0475 9.87718 11.1011 9.94921C11.1481 10.0124 11.1712 10.0902 11.1664 10.1688C11.1608 10.2584 11.0998 10.35 10.9777 10.5332L10.1583 11.7622C10.1004 11.849 10.0715 11.8924 10.0332 11.9239C9.99938 11.9517 9.96038 11.9726 9.91845 11.9853C9.87108 11.9997 9.81891 11.9997 9.71455 11.9997H8.38439C8.24616 11.9997 8.17704 11.9997 8.11823 11.9766C8.0663 11.9561 8.02033 11.923 7.98453 11.8802C7.94399 11.8317 7.92213 11.7661 7.87842 11.635L7.40317 10.2093C7.37739 10.1319 7.3645 10.0932 7.36111 10.0539C7.3581 10.0191 7.36059 9.98397 7.3685 9.9499C7.37742 9.91147 7.39565 9.87501 7.43211 9.80208L7.79312 9.08007C7.86647 8.93337 7.90314 8.86002 7.95963 8.81448C8.00941 8.77435 8.06968 8.74938 8.13326 8.74256C8.20541 8.73482 8.2832 8.76075 8.4388 8.81261L8.99998 8.99967ZM14.6666 7.99967C14.6666 11.6816 11.6819 14.6663 7.99998 14.6663C4.31808 14.6663 1.33331 11.6816 1.33331 7.99967C1.33331 4.31778 4.31808 1.33301 7.99998 1.33301C11.6819 1.33301 14.6666 4.31778 14.6666 7.99967Z"
          stroke="#667085"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2541_101034">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ValidIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 6.66634H2M10.6667 1.33301V3.99967M5.33333 1.33301V3.99967M5.2 14.6663H10.8C11.9201 14.6663 12.4802 14.6663 12.908 14.4484C13.2843 14.2566 13.5903 13.9506 13.782 13.5743C14 13.1465 14 12.5864 14 11.4663V5.86634C14 4.74624 14 4.18618 13.782 3.75836C13.5903 3.38204 13.2843 3.07607 12.908 2.88433C12.4802 2.66634 11.9201 2.66634 10.8 2.66634H5.2C4.0799 2.66634 3.51984 2.66634 3.09202 2.88433C2.71569 3.07607 2.40973 3.38204 2.21799 3.75836C2 4.18618 2 4.74624 2 5.86634V11.4663C2 12.5864 2 13.1465 2.21799 13.5743C2.40973 13.9506 2.71569 14.2566 3.09202 14.4484C3.51984 14.6663 4.0799 14.6663 5.2 14.6663Z"
        stroke="#667085"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DiscountIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2541_101047)">
        <path
          d="M5.99998 5.99967H6.00665M9.99998 9.99967H10.0066M10.6666 5.33301L5.33331 10.6663M6.33331 5.99967C6.33331 6.18377 6.18407 6.33301 5.99998 6.33301C5.81588 6.33301 5.66665 6.18377 5.66665 5.99967C5.66665 5.81558 5.81588 5.66634 5.99998 5.66634C6.18407 5.66634 6.33331 5.81558 6.33331 5.99967ZM10.3333 9.99967C10.3333 10.1838 10.1841 10.333 9.99998 10.333C9.81588 10.333 9.66665 10.1838 9.66665 9.99967C9.66665 9.81558 9.81588 9.66634 9.99998 9.66634C10.1841 9.66634 10.3333 9.81558 10.3333 9.99967ZM14.6666 7.99967C14.6666 11.6816 11.6819 14.6663 7.99998 14.6663C4.31808 14.6663 1.33331 11.6816 1.33331 7.99967C1.33331 4.31778 4.31808 1.33301 7.99998 1.33301C11.6819 1.33301 14.6666 4.31778 14.6666 7.99967Z"
          stroke="#667085"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2541_101047">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UsageIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.66665 4.66667L7.92295 3.17928C7.70892 2.7512 7.60189 2.53715 7.44223 2.38078C7.30103 2.24249 7.13086 2.13732 6.94403 2.07287C6.73276 2 6.49345 2 6.01484 2H3.46665C2.71991 2 2.34654 2 2.06133 2.14532C1.81044 2.27316 1.60647 2.47713 1.47864 2.72801C1.33331 3.01323 1.33331 3.3866 1.33331 4.13333V4.66667M1.33331 4.66667H11.4666C12.5868 4.66667 13.1468 4.66667 13.5746 4.88465C13.951 5.0764 14.2569 5.38236 14.4487 5.75869C14.6666 6.18651 14.6666 6.74656 14.6666 7.86667V10.8C14.6666 11.9201 14.6666 12.4802 14.4487 12.908C14.2569 13.2843 13.951 13.5903 13.5746 13.782C13.1468 14 12.5868 14 11.4666 14H4.53331C3.41321 14 2.85316 14 2.42533 13.782C2.04901 13.5903 1.74305 13.2843 1.5513 12.908C1.33331 12.4802 1.33331 11.9201 1.33331 10.8V4.66667ZM7.99998 11.3333V7.33333M5.99998 9.33333H9.99998"
        stroke="#667085"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UserGroupIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6666 14V12.6667C14.6666 11.4241 13.8168 10.38 12.6666 10.084M10.3333 2.19384C11.3106 2.58943 12 3.54754 12 4.66667C12 5.78579 11.3106 6.7439 10.3333 7.13949M11.3333 14C11.3333 12.7575 11.3333 12.1362 11.1303 11.6462C10.8597 10.9928 10.3405 10.4736 9.68714 10.203C9.19708 10 8.57582 10 7.33331 10H5.33331C4.0908 10 3.46955 10 2.97949 10.203C2.32608 10.4736 1.80695 10.9928 1.5363 11.6462C1.33331 12.1362 1.33331 12.7575 1.33331 14M8.99998 4.66667C8.99998 6.13943 7.80607 7.33333 6.33331 7.33333C4.86055 7.33333 3.66665 6.13943 3.66665 4.66667C3.66665 3.19391 4.86055 2 6.33331 2C7.80607 2 8.99998 3.19391 8.99998 4.66667Z"
        stroke="#667085"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#F4F4F5" />
      <path
        d="M21 11L11 21M11 11L21 21"
        stroke="#475467"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const GenerateIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 17.083C13.9121 17.083 17.0834 13.9117 17.0834 9.99967C17.0834 7.64506 15.9345 5.55878 14.1667 4.27084M10.8334 18.6663L9.16675 16.9997L10.8334 15.333M10.0001 2.91634C6.08806 2.91634 2.91675 6.08766 2.91675 9.99967C2.91675 12.3543 4.06564 14.4406 5.83341 15.7285M9.16675 4.66634L10.8334 2.99967L9.16675 1.33301"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PercentIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8334 4.16699L4.16675 15.8337M6.25008 5.41699C6.25008 5.87723 5.87699 6.25033 5.41675 6.25033C4.95651 6.25033 4.58341 5.87723 4.58341 5.41699C4.58341 4.95675 4.95651 4.58366 5.41675 4.58366C5.87699 4.58366 6.25008 4.95675 6.25008 5.41699ZM15.4167 14.5837C15.4167 15.0439 15.0437 15.417 14.5834 15.417C14.1232 15.417 13.7501 15.0439 13.7501 14.5837C13.7501 14.1234 14.1232 13.7503 14.5834 13.7503C15.0437 13.7503 15.4167 14.1234 15.4167 14.5837Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
